<template>
  <p :style="style">
    <strong v-if="value">
      {{ value || '-' }}
    </strong>
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'ServiceType',
  props: {
    value: String,
    small: Boolean,
    background: String,
  },
  computed: {
    style() {
      return {
        fontSize: '0.85rem',
        width: 'fit-content',
        padding: '5px',
        heigth: '10px',
        color: 'white',
        textAlign: 'center',
        borderRadius: '3px',
        background: this.background || 'gray',
      };
    },
  },
};
</script>

<style>
</style>